import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { DEFAULTS } from 'constants/defaults.constant';

import RealityLogo from 'assets/logos/rda_logo.png';
import PoweredByArkiv from 'assets/powered-by-arkiv.svg';

import SocialsBar from '../socials/SocialsBar';
import { Footer } from './Footer';
import styles from './LandingFooter.module.scss';

interface IFooter {
  className?: string;
  variant?: 'default' | 'referral' | 'events';
}

const LandingFooter = ({ className, variant = 'default' }: IFooter) => {
  const { t } = useTranslation();

  return (
    <footer className={[styles['footer'], styles[`footer--${variant}`], className].join(' ')}>
      <div className={styles['footer__container']}>
        <div className={styles['footer__content']}>
          <div className={styles['footer__top']}>
            <Link to="/" aria-label="Landing page">
              <div className="avatar tw-flex tw-flex-col tw-items-center tw-gap-[20px] lg:tw-flex-row lg:tw-gap-[40px]">
                <img src={RealityLogo} alt="Reality Metaverse" className="tw-w-full tw-max-w-[235px]" />
                <img src={PoweredByArkiv} alt="Golem Logo" className="tw-w-full tw-max-w-[169px]" />
              </div>
            </Link>
            <SocialsBar
              order={[
                { type: 'medium' },
                { type: 'discord' },
                { type: 'twitter' },
                { type: 'telegramChat' },
                { type: 'telegram' },
                { type: 'polygonscan' },
                { type: 'coinmarketcap' },
              ]}
              className={styles['nav-bar_social__list']}
              iconClassName={styles['nav-bar__social___icon']}
            />
          </div>
          <div className="tw-my-10 tw-hidden tw-h-[1px] tw-w-full tw-bg-[#1F408C] lg:tw-block" />
          <Footer variant={variant} />
          <div className="tw-my-10 tw-hidden tw-h-[1px] tw-w-full tw-bg-[#1F408C] lg:tw-block" />
          <div className={styles['footer__bottom']}>
            <p className={styles['footer__copyright']}>{t('copyright', { year: new Date().getFullYear() })}</p>
            <nav>
              <ul className={styles['nav-list']}>
                <li className={styles['nav-list__item']}>
                  <Link to={DEFAULTS.privacyPolicyLink} target="_blank">
                    Privacy Policy
                  </Link>
                </li>
                <li className={styles['nav-list__item']}>
                  <Link to={DEFAULTS.termsOfServiceLink} target="_blank">
                    Terms of Service
                  </Link>
                </li>
                <li className={styles['nav-list__item']}>
                  <Link to={DEFAULTS.licenseLink} target="_blank">
                    License
                  </Link>
                </li>
                <li className={styles['nav-list__item']}>
                  <a href={DEFAULTS.faqUrl} target="_blank" rel="noreferrer">
                    FAQ
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default LandingFooter;
